import { format, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'MMM-dd-yyyy');
}

export function fDate1(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDateTime(date) {
  return format(new Date(date), 'MMM-dd-yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
export function fDate12(date) {
  return format(new Date(date), 'MMM-dd-yyyy  p');
}

export function fDate12US(date) {
  return format(new Date(date), 'MM/dd/yyyy');
}
